import { CyberSourceGenerateKeyResponse } from "../types/CyberSource";
import CyberSourceClient from "./CyberSourceClient";
import RequestixClient from "./RequestixClient";

export const getCreditCardKey = (): Promise<CyberSourceGenerateKeyResponse> =>
  RequestixClient.get(`/cybersource/generatekey`).then((response) => response.data.entity);

export const createCreditCardToken = (flex) =>
  CyberSourceClient.post(`/flex/v1/tokens`, flex).then((response) => response.data);
